import { useState, useEffect, useRef } from 'react';
import ComponentsUtil, { deepCopy } from "../../utils/ComponentsUtil";
import { useTaskListStore, TASKLIST_ACTIONS } from "../../Store";
import {i18n} from "../../utils/GadgetUtils";

var mediaPropertiesLayouts;
var _layoutMap;
var _showBA;
var _deploymentType;
// Stores the timers for pending call variable operations.
var _pendingCallVariableTimers = {};

// store the call variables values for which the update is going on currently.
var _callVariablesSentForUpdate = {};

// Time (ms) to wait for event before failing the call control request.
var _EVENT_TIMEOUT = 10000;

// Length of time (ms) to display call variable edit error message before
// reverting back.
var _ERROR_CALLVARIABLE_EDIT_TIMEOUT = 15000;

var callvariableEditStatus = {
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    NO_DATA: 'NO_DATA',
    INFO: 'INFO'
};

function useCallVariableProps() {
    const [taskListState, taskListHandleActions] = useTaskListStore();
    const taskListStateRef = useRef(taskListState)

    useEffect(() => {
        taskListStateRef.current = taskListState;
    }, [taskListState]);


    function isExistingTask(taskId) {
        return taskListStateRef.current.taskList.find(task => task.taskId === taskId)
    }

    function setCallVariableEditStatus(dialogId, callVarEditStatus) {
  
        let task = isExistingTask(dialogId);
        if(task != undefined){
            task.callVarProps.callVariableEditStatus = callvariableEditStatus.INFO;
            taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });
            clearMessageTimer(task);
        }   
    }

    const _handleCallVariableUpdate = (callVariablePayLoad, dialog, _task) => {

        let task = isExistingTask(_task.taskId);
        task.callVarProps.callVariableEditStatus = callvariableEditStatus.IN_PROGRESS;
        taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });

        dialog.updateCallVariables(callVariablePayLoad, {
            error:  _createEditCallVariableErrHandler(dialog, 'FAILEDOP')
        });

        _callVariablesSentForUpdate[task.taskId] = callVariablePayLoad;

        _pendingCallVariableTimers[dialog._id] = setTimeout(
            _createEditCallVariableErrHandler(dialog, 'TIMEOUT'),
            _EVENT_TIMEOUT
        );

    };

    const checkSuccess = (_task, callVarName ) => {

        let taskId = _task.taskId;
        let task = isExistingTask(_task.taskId);
        let success = false;
        for(let x in _callVariablesSentForUpdate[taskId]){
            let callvar = x;
            let obj = callVarName;
            success = true;
            if(ComponentsUtil.encodeSpecialChars(obj[callvar]) != _callVariablesSentForUpdate[taskId][x]){
                success = false;
                break;
            }
        }
        if(success == true) {
            clearTimeout(_pendingCallVariableTimers[taskId]);
            clearMessageTimer(task);
            task.callVarProps.callVariableEditStatus = callvariableEditStatus.SUCCESS;
            taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });
            delete _callVariablesSentForUpdate[taskId];
        }

    }


    const clearMessageTimer = (_task) => {
        let task = isExistingTask(_task.taskId);

         setTimeout(() => {
            task.callVarProps.callVariableEditStatus = callvariableEditStatus.NO_DATA;
            task.callVarProps.callVariableError = '';
            taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });
        }, _ERROR_CALLVARIABLE_EDIT_TIMEOUT);
            
    };

    const _setEditCallVariableError = (errorCode, errorMessage, dialogId) => {
        let appearanceMsg, tmpMsg = i18n.getString('gadget.callcontrol.editcallvariable.CTIError.' + errorCode, errorMessage);
        let task = isExistingTask(dialogId);
        if(tmpMsg && tmpMsg.startsWith("???")){
          appearanceMsg = i18n.getString('gadget.callcontrol.nonvoice.editcallvariable.error', errorMessage);
        }  
        else {
            appearanceMsg = tmpMsg;
        } 
        task.callVarProps.callVariableError = appearanceMsg;
        taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });
    };

  
        /**
     * Create a closer to handle operation errors which occurred after an edit call variable update.
     * @param {Object} call
     *     jQuery object reference to call row.
     * @param {Dialog} dialog
     *     Dialog object.
     * @param {String} errorType
     *     The type of error the present on error.
     * @private
     */
        const _createEditCallVariableErrHandler = (dialog, errorType) => {

            return function (rsp) {
                let errorCode = 'unknown', apiError;

                console.log('_createEditCallVariableErrHandler(): An error occured for dialog id ' + dialog._id + ' with errorType ' + errorType);
                let errorMessage = i18n.getMsg('gadget.callcontrol.nonvoice.editcallvariable.error');

               
                let task = isExistingTask(dialog._id);
                
                task.callVarProps.callVariableEditStatus = callvariableEditStatus.ERROR;
                task.callVarProps.callVariableError = errorMessage;
                taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });

                if (rsp) {
                // Async Finesse errors.
                    if (rsp.status === 400 && rsp.object && rsp.object.ApiErrors) {
                    // clear action button // clear action button (during transfering to invalid no no btn will be displayed)
                        apiError = rsp.object.ApiErrors.ApiError;
                        if (apiError && apiError.ErrorType !== undefined) {
                            _setEditCallVariableError(apiError.ErrorData, apiError.ErrorMessage, dialog._id);
                        } 
                        console.log('_createEditCallVariableErrHandler(): An error occurred for dialog id ' +
                        dialog._id + ' with a HTTP response status of ' + rsp.status + ' and an api error code of ' + errorCode + ' errorMessage ' + apiError.ErrorMessage);
                    // HTTP 503 errors.
                    }
                } 
                clearMessageTimer(task); 
                delete _callVariablesSentForUpdate[task.taskId];             
            };
        };

    const escapeSpaces = function (string) {
        return string.replace(/\s/g, '\u00a0');
    };


    const _isUCCXDeployment = function () {
        return _deploymentType === 'UCCX';
    };

    const _updateCallVarArea = () => {
        var
            i,
            j,
            displayName,
            columns,
            callVariables,
            showInPopOver,
            mediaProperty,
            uiEditable,
            maxLength;

        if (_layoutMap) {
            columns = _layoutMap.columns;
            callVariables = {};

            // Iterate through each callvar type in each column in the layout
            // definition and create a placeholder for the value.
            for (i = 0; i < columns.length; i += 1) {
                callVariables[i] = [];

                for (j = 0; j < columns[i].length; j += 1) {
                    displayName = _layoutMap.columns[i][j].displayName;
                    showInPopOver = _layoutMap.columns[i][j].showInPopOver;
                    displayName = escapeSpaces(displayName);
                    mediaProperty = _layoutMap.columns[i][j].mediaProperty;
                    uiEditable = _layoutMap.columns[i][j].uiEditable;
                    if (mediaProperty.startsWith('callVariable')) {
                        maxLength = 40;
                    } else {
                        maxLength = 30;
                    }
                    callVariables[i].push({name: displayName, value: '', showInPopOver: showInPopOver, mediaProperty: mediaProperty, uiEditable: uiEditable, maxLength: maxLength});
                }
            }
        } else {
            console.log('_updateCallVarArea: could not get default call variable layout from server.');
        }
        return callVariables;
    };

    /* Update the media properties layout based on the given layout name.
     *
     * @param {String} layoutName
     *     THe name of the layout to use.
     * @private
     */
    const _updateMediaPropertiesLayout = (layoutName) => {
            let availableLayoutMaps = mediaPropertiesLayouts.getCollection(),
                currentMap, objectId;

            // Update our media properties layout
            for (objectId in availableLayoutMaps) {
                if (availableLayoutMaps.hasOwnProperty(objectId)) {
                    currentMap = availableLayoutMaps[objectId].getData();
                    if (currentMap.name === layoutName) {
                        _layoutMap = currentMap;
                        break;
                    } else if (currentMap.type === 'DEFAULT') {
                        _layoutMap = currentMap;
                    }
                }
            }
            return _layoutMap;
        };
    
   
        const _populateCallVariables = (_layoutMap, callVariables, callvars, _task) => {
            let columns = _layoutMap.columns;
            let BANames = ['AccountNumber', 'BuddyName', 'Campaign', 'DialedListID', 'Response', 'Status', 'TimeZone', 'CustomerNumber'];
            // Iterate through each callvar type in each column in the layout
            // definition and create a placeholder for the value.

            for (let i = 0; i < columns.length; i += 1) {
                for (let j = 0; j < columns[i].length; j += 1) {
                    let callVarName, callVarValue;
                    callVarName = columns[i][j].mediaProperty;
                    callVarValue = callvars[callVarName];
    
                    if ((_isUCCXDeployment()) && (callVarName === 'wrapUpReason')) {
                        callVarValue = callvars['wrapUpItems'];
                        if (callVarValue) {
                            let wrapUpItems = callVarValue.wrapUpItem;
                            if (Array.isArray(wrapUpItems)) {
                                callVarValue = wrapUpItems.sort().join();
                            } else {
                                callVarValue = wrapUpItems;
                            }
                        }
                    }

                    if (!callVarValue) {
                        callVarValue = '';
                    }

                    callVarValue = escapeSpaces(callVarValue);
                    callVariables[i][j].value = callVarValue;

                    // HIDE BA CALL VARS FOR NON OUTBOUND CALL
                    if (!_showBA) {
                        for (let count = 0; count < BANames.length; count += 1) {
                            if (callVarName === 'BA' + BANames[count]) {
                                callVariables[i][j].hide = true;
                            }
                        }
                    }
                };
            };
        };

       /*  Method to set showBA
        **/
        const _setShowBA = (status) => {
                _showBA = !!status;
            };
    

    const _updateCallVariables = (callvars, task, myParticipants, dialog, _mediaPropertiesLayouts, user) => {
        let headerMPName,
            headerMPValue = '';

        mediaPropertiesLayouts = _mediaPropertiesLayouts;
        
        // always give preference to user.layout if it exists
        // otherwise use user.Layout if it exists
        _updateMediaPropertiesLayout(callvars['user.layout'] || callvars['user.Layout']);
        let callVariables = _updateCallVarArea();

        if (_layoutMap) {
            headerMPName = _layoutMap.header.mediaProperty;

            if (headerMPName) {
                headerMPValue = callvars[headerMPName];
            }
            _setShowBA(callvars.BAStatus);
            // Update call variable property fields for the call.
            // For each callvar category name in each column in the UI (that was
            // setup by _createCallVarArea()), replace the text with the one
            // given in the dialog object.
            _populateCallVariables(_layoutMap, callVariables, callvars, task);
        }

        task.callVarProps = { 
            mediaProperties: {
            DNIS: callvars.DNIS,
            callType: callvars.callType,
            dialedNumber: callvars.dialedNumber,
            outboundClassification: callvars.outboundClassification,
            callVariables
        },
        show: true,
        myParticipant: myParticipants
    };
    task.callVarProps.taskId = dialog._id;
    taskListHandleActions({ type: TASKLIST_ACTIONS.UPDATE, task });

    };


    return {
        _updateCallVariables,
        _handleCallVariableUpdate,
        setCallVariableEditStatus,
        checkSuccess
    };
}

export default useCallVariableProps;